// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_right_body = /** @type {(inputs: {}) => string} */ () => {
	return `You have 15 days from the date of delivery to return your purchase. Items must be unused, in their original packaging, and in the same condition you received them.`
};

const el_refunds_right_body = /** @type {(inputs: {}) => string} */ () => {
	return `Έχετε 15 ημέρες από την ημερομηνία παράδοσης για να επιστρέψετε την αγορά σας. Τα προϊόντα πρέπει να είναι αχρησιμοποίητα, στην αρχική τους συσκευασία και στην ίδια κατάσταση που τα παραλάβατε.`
};

const ru_refunds_right_body = /** @type {(inputs: {}) => string} */ () => {
	return `У вас есть 15 дней с даты получения для возврата покупки. Товары должны быть неиспользованными, в оригинальной упаковке и в том же состоянии, в котором вы их получили.`
};

const he_refunds_right_body = /** @type {(inputs: {}) => string} */ () => {
	return `יש לכם 15 יום מתאריך הקבלה להחזיר את הרכישה. המוצרים חייבים להיות שלא נעשה בהם שימוש, באריזתם המקורית ובאותו מצב שקיבלתם אותם.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_right_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_right_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_right_body", locale)
	if (locale === "en") return en_refunds_right_body(inputs)
	if (locale === "el") return el_refunds_right_body(inputs)
	if (locale === "ru") return ru_refunds_right_body(inputs)
	if (locale === "he") return he_refunds_right_body(inputs)
	return "refunds_right_body"
};